export default "__VITE_ASSET__D3IOU9j$__"